// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8701dc61","634":"3a2d9513","817":"981887f0"}[chunkId] + ".chunk.js";
};